/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './MobileMind.css';
import ReactEcharts from 'echarts-for-react'

import logoPic from './logo.png'



class MobileMind extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.getOption=this.getOption.bind(this)
  }


  getOption=()=>{

    // console.log(this.props)
    var itemStyle = {
      normal: {
        opacity: 0.7,
    
        borderWidth: 1,
        borderColor: '#000'
      }
    };
    
    // let qopData = [
    //   {
    //     name: '海尔',
    //     value: '50',
    //     grayColor: true
    //   }, {
    //     name: '美的',
    //     value: '20',
    //     grayColor: false
    //   }, {
    //     name: '格力',
    //     value: '44',
    //     grayColor: true
    //   }
    // ]
    // console.log(this.props.json)
    let qopData=this.props.json
    // var isColor=function(){     if(grayColor){         color:'#ccc'     }else{
    //      color:'#ffd70d'     } }
    var mmData = []
    var legendData = []
    function makeData(qopData) {
    
      for (var i = 0; i < qopData.length; i++) {
        var ss = qopData[i].grayColor
          ? '#44548f'
          : '#ffd70d'
        mmData.push({
          value: qopData[i].value, name: qopData[i].name,
          // itemStyle.normal.color:qopData[i].grayColor
          itemStyle: {
            normal: {
              color: ss
            }
          }
        })
        legendData.push(qopData[i].name)
    
      }
      // console.log(mmData,legendData)
      return {mmData: mmData, legendData: legendData}
    
    }
    makeData(qopData)
    // console.log(this.props)

    let aaa=this.props.items
    let legendTxt=aaa.map(i=>i.name).join(' vs ')
    const propsIndustry=aaa.length>1?'- 品牌对比': this.props.industry?'- '+this.props.industry:'- '+this.props.geo
    // console.log(this.props+'接收到的数据')
    const {items}=this.props
    let option = {
    
      title: {
        text: `心智占有率 ${propsIndustry} - ${legendTxt}`,
        subtext: '数据来源：数字品牌榜',
        // sublink:'https://www.dbrank.net',
        x: '20',
        textStyle:{
          fontSize:32,
          color:'#333'
        }
      },
      color: ['#ffd70d'],
      tooltip: {
        trigger: 'item',
        position: [
          '45%', '42%'
        ],
        formatter: `{d}%<br/>{b}`,
        backgroundColor: 'rgba(0,0,0,0)',
        padding: 20,
        textStyle: {
          color: '#eead81',
          fontWeight: 400,
          fontSize: 26,
        },
        // extraCssText:'box-shadow: 0 0 3px rgba(0,0,0,0.3)'
    
      },
      graphic: [
        {
          type: 'rect',
          z: 80,
          left: '20',
          top: '70',
          shape: {
            width: 120,
            height: 84
          },
          style: {
            fill: '#ffd70d',
            stroke: '#999'
          }
        }, {
          type: 'text',
          left: '20',
          top: 75,
          z: 100,
          style: {
            text: ' ● 阴影区颜色为黄色，',
            // fill:'#ffd70d',
            stroke: '#ffd70d',
            font: '12px "STHeiti", sans-serif'
          }
        },{
          type: 'text',
          left: '30',
          top: 95,
          z: 100,
          style: {
            text: ' 表明好感度为正值；',
            // fill:'#ffd70d',
            stroke: '#44548f',
            font: '12px "STHeiti", sans-serif'
          }
        },{
          type: 'text',
          left: '30',
          top: 115,
          z: 100,
          style: {
            text: ' 若为蓝色，',
            // fill:'#ffd70d',
            stroke: '#44548f',
            font: '12px "STHeiti", sans-serif'
          }
        },{
          type: 'text',
          left: '30',
          top: 135,
          z: 100,
          style: {
            text: ' 表明好感度为负值。',
            // fill:'#ffd70d',
            stroke: '#44548f',
            font: '12px "STHeiti", sans-serif'
          }
        },{
          type: 'image',
          id: 'logo',
          right: 30,
          bottom: 20,
          z: -10,
          bounding: 'raw',
          origin: [75, 75],
          style: {
              image: logoPic,
              width: 220,
              height: 72,
              opacity: 1
          }
        },
      ],
      legend: {
        show: false,
        type:'scroll',
        orient: 'vertical',
        padding: 20,
        top:'20',
        right: '10',
        bottom:'20',
        y: 'bottom',
        data: legendData,
        inactiveColor:'#ccc',
      },
      toolbox: {
        show: true,
        feature: {
          restore: {},
          saveAsImage: {},
          // dataView:{
            
          // }
        },
        right: 20
      },
      calculable: true,
      series: [
        {
          name: '心智占有率',
          type: 'pie',
          radius: [
            '20%', '75%'
          ],
          center: [
            '50%', '50%'
          ],
          startAngle:90,
          roseType: 'area',
          avoidLabelOverlap: true,
          label: {
            normal: {
              // formatter: '{b|{b}}\n{hr|}\n{a|{a}：}{per|{d}%}\n{hr|}\n {a|DB值：}{per|{c}}',
              formatter: `{b|{b}} {per|{d}%}`,
              // formatter: function(params,data){
              //   console.log(params,data)
              //   return `{b|${params.name}}${params.color=='#ccc'?'-':''}{per|{d}}%}`
              // },
              backgroundColor: '#f2f2f2',
              borderColor: '#aaa',
              // borderWidth: 1,
              borderRadius: 4,
              padding: [
                0, 0
              ],
              // shadowBlur:3, shadowOffsetX: 2, shadowOffsetY: 2, shadowColor: '#999',
              // padding: [0, 7],
              rich: {
                a: {
                  color: '#999',
                  lineHeight: 24,
                  align: 'center',
                },
                // abg: {     backgroundColor: '#333',     width: '100%',     align: 'right',
                //  height: 22,     borderRadius: [4, 4, 0, 0] },
                hr: {
                  borderColor: '#aaa',
                  width: '100%',
                  borderWidth: 0.5,
                  height: 0
                },
                b: {
                  fontSize: 22,
                  lineHeight: 24,
                  color: '#666',
                  align: 'center'
                },
                per: {
                  color: '#fff',
                  backgroundColor: '#334455',
                  align: 'center',
                  padding: [
                    2, 4
                  ],
                  fontSize:22,
                  borderRadius: 2
                }
    
              }
            },
            emphasis: {
              show: true
            }
    
          },
          lableLine: {
            normal: {
              length: 1000,
              length2: 30,
              show: true
            },
            emphasis: {
              show: true
            }
          },
          // data:mmData.sort(function(a,b){return b.value-a.value}),
          data: mmData.sort((a, b) => b.value - a.value),
          itemStyle: itemStyle
        }
    
      ]
    }
    return option
  }

  render() {
    // console.log(this.props)
    return (<ReactEcharts
      option={this.getOption()}
      style={{
        height: '750px',
        width: '1280px',
        marginTop: '20px',
        borderRadius: '4px'
      }}
      className={s.charts}
      notMerge={true}
      lazyUpdate={true}
      theme={"theme_name"}
      onChartReady={this.onChartReadyCallback}/>)

  }
}

export default withStyles(s)(MobileMind);



// WEBPACK FOOTER //
// src/components/MobileMind/MobileMind.js